export default "__VITE_ASSET__VfFqR0ef__"